import type {ComponentType} from "react";
import {Redirect} from "react-router-dom";

import {usePolarisAccess} from "./usePolarisAccess";

// Route-level guard: the sidebar only hides the link, so the pages check too.
// The Polaris API enforces the same rule (403) for every endpoint.
export function withPolarisAccess<P extends object>(Page: ComponentType<P>) {
	const Guarded = (props: P) => {
		const enabled = usePolarisAccess();
		if (enabled === null) return null;
		if (!enabled) return <Redirect to="/home" />;

		return <Page {...props} />;
	};
	Guarded.displayName = `withPolarisAccess(${Page.displayName || Page.name || "Page"})`;

	return Guarded;
}
